import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "fle-list-w"
};
const _hoisted_3 = {
  class: "file-item flex-between"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "dialog-footer"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { UploadFilled } from '@element-plus/icons-vue';
import { uploadProjectApi } from '@/service/modules/user';
export default /*@__PURE__*/_defineComponent({
  __name: 'upload-project-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const subBtnLoading = ref(false);
    const fileList = ref([]);
    function handleSeleceFile(files) {
      let file = files.file;
      // console.log('file', file)
      fileList.value.push(file);
    }
    function handleDelFile(index) {
      fileList.value.splice(index, 1);
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      fileList.value = [];
      emit('closeDialog');
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      submit();
    }
    async function submit() {
      // console.log('fileList', fileList.value)
      if (fileList.value.length === 0) {
        return ElMessage.error('请先选择xlsx文件');
      }
      for (let item of fileList.value) {
        if (item.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          ElMessage.error('文件仅支持xlsx格式');
          return;
        }
      }
      const formData = new FormData();
      for (let item of fileList.value) {
        formData.append("files", item);
      }
      subBtnLoading.value = true;
      console.log('fileList', fileList.value);
      console.log('formData', formData);
      try {
        await uploadProjectApi(formData);
        ElMessage.success('档案导入成功');
        subBtnLoading.value = false;
        closeDialog();
        emit('restData');
      } catch {
        subBtnLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_CloseBold = _resolveComponent("CloseBold");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "上传档案",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[1] || (_cache[1] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          class: "upload-demo",
          "http-request": handleSeleceFile,
          "show-file-list": false,
          multiple: "",
          drag: ""
        }, {
          tip: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "el-upload__tip"
          }, " 档案仅支持xlsx格式 ", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", {
              class: "close",
              onClick: $event => handleDelFile(index)
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_CloseBold)]),
              _: 1
            })], 8, _hoisted_4)]);
          }), 256))])]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
            _: 1
          }), _cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "el-upload__text"
          }, [_createTextVNode(" 拖动文件或 "), _createElementVNode("em", null, "点击上传")], -1))]),
          _: 1
        })]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});